const HIGHLIGHTS = [
  { metric: '3–5x', label: 'Faster than traditional agencies', detail: 'AI-augmented workflows compress timelines dramatically' },
  { metric: '100%', label: 'On-time delivery rate', detail: 'Zero missed deadlines across all projects' },
  { metric: '24/7', label: 'Availability', detail: 'Our team operates continuously — no timezone gaps' },
  { metric: '$3K–$50K', label: 'Project range', detail: 'From MVPs to enterprise platforms' },
];

const GUARANTEES = [
  'Fixed-price quotes — no hourly surprises',
  'Weekly progress demos on staging',
  'Full source code ownership from day one',
  '30 days of free post-launch support',
  'Money-back guarantee if we miss the deadline',
];

const WhyUs = () => (
  <section className="r-section why" id="why-us">
    <div className="r-wrap">
      <div className="r-tag r-reveal">Why us</div>
      <h2 className="r-head r-reveal">
        We don&apos;t just build software. <span className="r-gtxt">We de-risk your investment.</span>
      </h2>

      <div className="why-grid">
        {HIGHLIGHTS.map((item, i) => (
          <div key={item.label} className={`why-card r-reveal r-d${(i % 6) + 1}`}>
            <div className="why-metric">{item.metric}</div>
            <div className="why-label">{item.label}</div>
            <div className="why-detail">{item.detail}</div>
          </div>
        ))}
      </div>

      <div className="why-guarantees r-panel r-reveal">
        <div className="why-guarantees-label">Our guarantees</div>
        <div className="why-glist">
          {GUARANTEES.map((g) => (
            <div key={g} className="why-gitem">
              <span className="why-check">✓</span>
              <span>{g}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default WhyUs;
